// Watch for changes to the responsive menu and add a class to the top nav buy rocc link when the menu is open
// This is used to hide the top nav buy rocc link when the mobile menu is open
// This is a workaround for the fact that the mobile menu is not part of the top nav buy rocc link
document.addEventListener('DOMContentLoaded', function() {
    const responsiveMenu = document.querySelector('ul#responsiveMenu');
    const topNavBuyRocc = document.querySelector('nav a.top-nav-buy-rocc');
    const customerLinks = document.querySelector('div.customer-links');
    const headerNav = document.getElementById('header-navigation');

    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.attributeName === 'class') {
                if (responsiveMenu.classList.contains('open')) {
                    topNavBuyRocc.classList.add('mobile-menu-open');
                    headerNav.classList.add('mobile-menu-open');
                    customerLinks.classList.add('mobile-menu-open');
                } else {
                    topNavBuyRocc.classList.remove('mobile-menu-open');
                    headerNav.classList.remove('mobile-menu-open');
                    customerLinks.classList.remove('mobile-menu-open');
                }
            }
        });
    });

    observer.observe(responsiveMenu, {
        attributes: true // configure it to listen to attribute changes
    });
});